import { BundleTypeKeys } from '@/store';
import { api, buildQueryString } from '../core';

export const BundleDownloadStatusType = {
  IN_PROGRESS: 'IN_PROGRESS', // Nurse is still working on the bundle – nobody has requested download.
  DOWNLOAD_PREPARING: 'DOWNLOAD_PREPARING', // Download is being prepared.
  DOWNLOAD_PREPARATION_FAILED: 'DOWNLOAD_PREPARATION_FAILED', // Download preparation failed – user can retry but it probably won’t work.
  DOWNLOAD_READY: 'DOWNLOAD_READY', // Download is ready.
} as const;

export type BundleDownloadStatusTypeKeys = (typeof BundleDownloadStatusType)[keyof typeof BundleDownloadStatusType];

interface BundleDownloadStatusResponse {
  status: BundleDownloadStatusTypeKeys;
}

type BundleDownloadStatusProps = {
  bundleId: string;
  bundleKey?: BundleTypeKeys;
};

const bundleDownloadStatusApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Query for checking the download status of a specific bundle.
     * Implements a long polling mechanism to continuously check the status
     * until it reaches 'DOWNLOAD_READY'.
     */
    bundleDownloadStatus: builder.query<BundleDownloadStatusResponse, BundleDownloadStatusProps>({
      query: (params: BundleDownloadStatusProps) => {
        const queryString = buildQueryString(params, { bundleId: 'bundleId' });

        return {
          url: `bundle/download-status?${queryString}`,
          method: 'GET',
        };
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints.
 */
export const { useLazyBundleDownloadStatusQuery } = bundleDownloadStatusApi;
export const { resetApiState: bundleDownloadStatusResetApiState } = bundleDownloadStatusApi.util;
